// Outcome codes of Remove's cloud delete (useCollection's deleteCloudCollection).
// Not user-facing text: kept in a *.codes.ts file, which the literal guard
// (eslint.i18n.config.js) skips by design.

export const CLOUD_DELETE = {
  /** The confirmed collection's row is gone and the legacy metadata cleared. */
  deleted: 'deleted',
  /** Retryable; may or may not have deleted (verification decides next time). */
  failed: 'failed',
  /** The account changed before anything was deleted. */
  identityBefore: 'identity_before',
  /**
   * The account changed AFTER the removal was fully confirmed (row read back
   * absent AND legacy metadata cleared). Nothing left to do in the cloud.
   */
  identityAfter: 'identity_after',
  /**
   * The account changed after a delete was ATTEMPTED but before the read-back
   * and the metadata clear both confirmed it. The account copy may survive:
   * retryable, but only as the confirming account.
   */
  incomplete: 'incomplete',
  /** The account's row holds a different collection than the confirmed one,
   *  which the device knew to be in the account: nothing deleted. */
  collectionChanged: 'collection_changed',
  /** The collection never reached the account (not cloud-synced) and the
   *  account's row, if any, is some other collection: nothing to delete. */
  notInAccount: 'not_in_account',
  /** The legacy metadata could not be read to decide whether it is this
   *  collection's pointer: retryable, nothing changed. */
  metadataUnknown: 'metadata_unknown',
} as const

export type CloudDeleteOutcome = typeof CLOUD_DELETE[keyof typeof CLOUD_DELETE]
